import { i18n } from '@/commons/utils';

export function PayonCreditCardWidget(params) {
  const widget = this;

  widget.template = () => {
    const redirectionUrlInput = document.getElementById('redirectionUrl');
    if (params.props && params.props.actionType === 'REFUND') {
      const url = Cube.Utils.localizeUri(`/account/myRefunds/confirmation?orderId=${params.props.orderId}&refundId=${params.props.refundId}`);
      widget.redirectionUrl = `${window.location.protocol}//${window.location.host}${url}`;
    } else if (redirectionUrlInput !== null) {
      widget.redirectionUrl = `${redirectionUrlInput.value}?orderId=${params.props.orderId}`;
    }
    return `<div class="dkt-payon_widget-container">
      <form class="wpwl-control-accountIban paymentWidgets" action="${widget.redirectionUrl}" method="POST">${params.props.cardListString}</form>
    </div>`;
  };

  widget.isSubmittable = () => document.querySelectorAll('.wpwl-hint').length === 0;

  widget.render = () => {
    window.wpwlOptions = {
      style: 'plain',
      validation: true,
      paymentTarget: '_top',
      labels: {
        cvv: i18n('payment.primary.payon.cvv'),
        cardHolder: i18n('payment.primary.payon.cardHolder'),
        cardNumber: i18n('payment.primary.payon.cardNumber'),
        mmyy: i18n('payment.primary.payon.expiryDate'),
        cardNumberError: i18n('payment.primary.errorMessage.cardNumberError'),
        expiryMonthError: i18n('payment.primary.errorMessage.expiryMonthError'),
        expiryYearError: i18n('payment.primary.errorMessage.expiryYearError'),
        cvvError: i18n('payment.primary.errorMessage.cvvError'),
        cardHolderError: i18n('payment.primary.errorMessage.cardHolder')
      },
      onReady: () => {
        document.querySelector('[name="card.number"]').setAttribute('tabindex', '1');
        document.querySelector('.wpwl-control-cardHolder').setAttribute('tabindex', '2');
        document.querySelector('.wpwl-control-expiry').setAttribute('tabindex', '3');
        document.querySelector('[name="card.cvv"]').setAttribute('tabindex', '4');
        document.dispatchEvent(new CustomEvent('payonReady'));
      },
      onBeforeSubmitCard: () => {
        if (document.querySelectorAll('.wpwl-hint:not(.wpwl-hint--card-holder)').length === 0) {
          if (window.wpwlOptions.isReadyToSubmit === true) {
            return true;
          }
          document.dispatchEvent(new CustomEvent('noPayonError'));
          return false;
        }
        return false;
      }
    };
    return widget.template();
  };
}



// WEBPACK FOOTER //
// ./src/checkout/payment/payment-creditcard-widget.js